import type { ReactNode } from "react";

type InlineMarkdownProps = {
  text: string;
};

export default function InlineMarkdown({ text }: InlineMarkdownProps) {
  const parts = text.split(/(`[^`]+`|\*\*[^*]+\*\*)/g);

  return (
    <>
      {parts.map((part, index): ReactNode => {
        if (part.startsWith("**") && part.endsWith("**")) {
          return <strong key={index}>{part.slice(2, -2)}</strong>;
        }

        if (part.startsWith("`") && part.endsWith("`")) {
          return (
            <code
              key={index}
              className="rounded bg-gray-100 px-1 py-0.5 font-mono text-[0.92em] text-gray-800"
            >
              {part.slice(1, -1)}
            </code>
          );
        }

        return part;
      })}
    </>
  );
}
